(function(angular) {
  'use strict';

  angular
    .module('bento-fm.core', []);
}(window.angular));

(function (angular) {
  'use strict';

  angular.module('bento-fm.core').directive('bentoFmField', FmField);
  angular.module('bento-fm.core').controller('bentoFmFieldController', FmFieldController);

  FmField.$inject = ['$log'];

  function FmField($log) {
    return {
      restrict  : 'A',
      require   : ['^bentoFmForm', 'ngModel', '?^bentoFmGroup', 'bentoFmField'],
      controller: 'bentoFmFieldController',
      link      : function (scope, element, attrs, ctrls) {
        if (!ctrls[1]) {
          // fm-field must have a model and a form
          $log.warn('Please watch, this element doesn\'t have a model', element);
          return;
        } else if (!ctrls[0].element) {
          $log.warn('`bento-fm-form` is missing at the parent level', element);
          return;
        }

        ctrls[3].init(ctrls);
      }
    };
  }

  FmFieldController.$inject = ['$parse', '$scope', '$element', '$attrs', '$timeout', '$log', 'FMUtilsService', 'FMErrorHandlerService'];

  function FmFieldController($parse, $scope, $element, $attrs, $timeout, $log, FMUtilsService, FMErrorHandlerService) {
    var self = this;
    var ngModelCtrl;
    var parentFormCtrl;
    var parentGroupCtrl;

    self.$touched = false;
    self.$invalid = false;
    self.$pristine = true;

    this.init = function (ctrls) {

      ngModelCtrl = ctrls[1];
      parentFormCtrl = ctrls[0];
      parentGroupCtrl = ctrls[2];

      /*
      Override $touched with setter and getter
       */
      Object.defineProperty(ngModelCtrl, '$touched', {
        get: function () {
          return self.$touched;
        },
        set: function (v) {
          self.$touched = v;
          if (v) {
            self.processNGModelErrorObject();
          }
        }
      });

      /*
      Override $invalid with setter and getter
       */
      Object.defineProperty(ngModelCtrl, '$invalid', {
        get: function () {
          return self.$invalid;
        },
        set: function (v) {
          if (self.$invalid !== v) {
            self.$invalid = v;
            if (!self.validateOnBlurOnly) {
              self.processNGModelErrorObject();
            }
          }
        }
      });

      Object.defineProperty(ngModelCtrl, '$pristine', {
        get: function () {
          return self.$pristine;
        },
        set: function (p) {
          self.$pristine = p;
          self.setPristine();
        }
      });

      /*
       * 1. Only when the attribute is defined & the attribute value is not null or
       * 2. If errorHandler attribute is null or
       * 3. look at the parent level (form level)
       */
      if ($attrs.errorHandler && $attrs.errorHandler !== 'null') {
        this.errorHandler = $parse($attrs.errorHandler);
      } else if ($attrs.errorHandler && $attrs.errorHandler === 'null') {
        this.errorHandler = undefined;
      } else if (parentGroupCtrl && parentGroupCtrl.element && parentGroupCtrl.element.attr('error-handler')) {
        this.errorHandler = $parse(parentGroupCtrl.element.attr('error-handler'));
      } else if (parentFormCtrl.element && parentFormCtrl.element.attr('error-handler')) {
        this.errorHandler = $parse(parentFormCtrl.element.attr('error-handler'));
      }

      /*
       * 1. Only when the attribute is defined & the attribute value is not null or
       * 2. If validateOnBlurOnly attribute is null or
       * 3. look at the parent level (form level)
       * 
       * (default is `false`) Flag that validates form field only during focus out.
       * If set to true, BFM will not show error messages instantly as on when the user
       * is keying in the values.
       */
      var expressionValidateOnBlurOnly;
      if ($attrs.validateOnBlurOnly && $attrs.validateOnBlurOnly !== 'null') {
        expressionValidateOnBlurOnly = $parse($attrs.validateOnBlurOnly);
      } else if ($attrs.validateOnBlurOnly && $attrs.validateOnBlurOnly === 'null') {
        expressionValidateOnBlurOnly = undefined;
      } else if (parentGroupCtrl && parentGroupCtrl.element && parentGroupCtrl.element.attr('validate-on-blur-only')) {
        expressionValidateOnBlurOnly = $parse(parentGroupCtrl.element.attr('validate-on-blur-only'));
      } else if (parentFormCtrl.element && parentFormCtrl.element.attr('validate-on-blur-only')) {
        expressionValidateOnBlurOnly = $parse(parentFormCtrl.element.attr('validate-on-blur-only'));
      }

      if(expressionValidateOnBlurOnly) {
        this.validateOnBlurOnly = expressionValidateOnBlurOnly();
      }

      $element.bind('focusout', function () {
        if (self.validateOnBlurOnly) {
          self.processNGModelErrorObject();
        }
        if (parentGroupCtrl && parentGroupCtrl.setBlurred) {
          $timeout(function () {
            parentGroupCtrl.setBlurred();
          });
        }
      });

      // set id and label for this element
      this.setId($element, ctrls);
      FMUtilsService.addLabel($element, $attrs, parentFormCtrl.element);

      //validate the unique id
      var idValue = FMUtilsService.getAttribute($element, 'id');
      ngModelCtrl.$validators[idValue] = function () {
        var noErrors = angular.equals(ngModelCtrl.$error, {});

        /*
         * call parent's set changed, only when there are no field level errors
         * like, required, pattern, min, max
         */
        if (noErrors && parentGroupCtrl && parentGroupCtrl.setChanged) {
          parentGroupCtrl.setChanged(true);
        }

        // only when there are errors
        if (!noErrors && !self.validateOnBlurOnly) {
          self.processNGModelErrorObject();
        }

        // always return - the above if conditions will take care of the rest
        return true;
      };

      $element.one('$destroy', function () {
        FMErrorHandlerService.resetError($element);
      });

      self.validationObject = $parse($attrs.validations)($scope) || {};

      var elementName = FMUtilsService.getAttribute($element, 'name');
      if (!elementName) {
        $log.error('"name" attribute is required for "bento-fm-field"', $element[0]);
      }
    };

    /**
     * the need for the timeout is to get the updated $touched property.
     * devs may reset the form either by calling $setPristine followed
     * by $setUntouched or vice versa
     */
    this.setPristine = function () {
      $timeout(function () {
        if (self.$pristine && !self.$touched) {
          FMErrorHandlerService.resetError($element);
        }
      });
    };

    /**
     * Set `id` and `aria-labelledby` to make this input unique
     * @param element
     */
    this.setId = function (element) {
      var idValue = FMUtilsService.generateRandomId();

      // set 'id' attribute, if not present - setAttribute won't add if id value is already present
      FMUtilsService.setAttribute(element, 'id', idValue);
      FMUtilsService.setAttribute(element, 'aria-labelledby', FMUtilsService.getAttribute(element, 'id'));
    };

    /**
     * Process AngularJS error messages from NgModelController
     *
     * @param errorObject
     * @param element
     * @param attrs
     * @param ctrls
     * @param validationObject
     */
    this.processNGModelErrorObject = function () {
      var errorObject = ngModelCtrl.$error;

      /*
       * do nothing without touched - simply return
       */
      if (ngModelCtrl && !ngModelCtrl.$touched) {
        return;
      }

      if (!angular.equals(errorObject, {})) { //if there're error messages
        /*
         * when using 'bento-number-input' directive, without entering any data if that element is
         * blurred, errorObject brings all validation attributes - min, max, required (from the
         * example that i had). Technically, if the element is touched, and not 'DIRTY' check only
         * required attribute and show error message corresponding to that
         */
        if (!ngModelCtrl.$dirty) {
          // touched by nothing entered - dirty = false
          if (errorObject.required) {
            errorObject = {required: true};
          } else {
            return;
          }
        }
        var errorMessage = '';
        var formControlName;
        if ($attrs.bentoFmLabel) {
          // do not format the label
          formControlName = $attrs.bentoFmLabel;
        } else {
          formControlName = FMUtilsService.formatCamelCaseString(FMUtilsService.UCFirst($attrs.name || $attrs.ngModel));
        }
        if (formControlName && formControlName.length) {
          // look for 'name' attribute
          var errorKeys = Object.keys(errorObject); // fetch list of keys from errorObject
          if (errorKeys) {
            for (var i = 0; i < errorKeys.length; i++) {
              errorMessage = self.getErrorMessage(errorKeys[i]);
              if (errorMessage.length) {
                errorMessage = FMUtilsService.formatValidationMessage(errorMessage, formControlName, $attrs[errorKeys[i]]);
                break; // show only 1 error, if found, break from the loop
              }
            }
          }
        }
        if (this.errorHandler) {
          this.errorHandler($scope, {hasError: true, element: $element, message: errorMessage});
        }
        if (!FMUtilsService.getAttribute($element, 'aria-errormessage')) {
          FMErrorHandlerService.constructErrorElement($element);
        }
        FMErrorHandlerService.showError($element, errorMessage);
      } else {
        if (this.errorHandler) {
          this.errorHandler($scope, {hasError: false, element: $element, message: ''});
        }
        if (!FMUtilsService.getAttribute($element, 'aria-errormessage')) {
          FMErrorHandlerService.constructErrorElement($element);
        }
        // no error - reset all and show it as if it never happened
        FMErrorHandlerService.resetError($element);
      }
    };

    /**
     * Retrieve error messages from validation object based on the current error status
     *
     * @param key
     * @param formControlName
     * @returns {string}
     */
    this.getErrorMessage = function (key) {
      var errorMessage;
      if (self.validationObject[key]) {
        errorMessage = self.validationObject[key];
      } else if (parentGroupCtrl) {
        errorMessage = parentGroupCtrl.getErrorMessageByKey(key);
      } else {
        errorMessage = parentFormCtrl.getErrorMessageByKey(key);
      }
      return errorMessage;
    };
  }
}(window.angular));

(function(angular) {
  'use strict';

  angular.module('bento-fm.core').directive('bentoFmForm', FmForm);
  angular.module('bento-fm.core').controller('bentoFmFormController', FmFormController);

  FmForm.$inject = ['$log'];
  function FmForm ($log) {
    return {
      restrict: 'A',
      require: ['bentoFmForm','?^^bentoFmForm'],
      controller: 'bentoFmFormController',
      link: function(scope, element, attrs, ctrls) {
        ctrls[0].init(ctrls[1]);
      }
    };
  }

  FmFormController.$inject = ['$log', '$parse', '$scope', '$element', '$attrs', 'FMUtilsService'];
  function FmFormController($log, $parse, $scope, $element, $attrs, FMUtilsService) {
    var self = this;
    var validationObject;
    this.element = $element;

    this.init = function(parentCtrl) {
      this.parentCtrl = parentCtrl;
      validationObject = $parse($attrs.validations)($scope) || {};

      if (validationObject) {
        validationObject.ignore = validationObject.ignore || {};
        self.processFormElements($element.children(), validationObject, $parse);
      }
    };

    /**
     * Get error message from this group level
     */
    self.getErrorMessageByKey = function(key){
      var errorMessage;
      if(validationObject && (errorMessage = validationObject[key])){
        return errorMessage;
      }else if(self.parentCtrl){
        return self.parentCtrl.getErrorMessageByKey(key);
      }else if(FMUtilsService.defaultValidationMessages[key]){
        return FMUtilsService.defaultValidationMessages[key];
      }else{
        return FMUtilsService.defaultValidationMessages['unknown'];
      }
    };

    /**
     * Process one element after other iteratively
     * @param elements
     * @param validationObject
     * @param $parse
     */
    this.processFormElements = function(elements, validationObject, $parse) {
      var self = this;
      var groupName;
      angular.forEach(elements, function (element) {
        groupName = '';
        var angularElement = angular.element(element);
        /**
         * if a group element is found
         * 1. add name attributes to it
         * 2. if this group element contains its own error-container, use it,
         * else use parent's error container
         */
        if(angularElement.attr('bento-fm-group')) {
          // only if dev specifies the group name
          groupName = angularElement.attr('bento-fm-group');
          FMUtilsService.setAttribute(angularElement, 'name', groupName);
        }

        /**
         * Check if the group element has any validation object,
         * if present set 'validations' attribute at group level.
         * bento-fm-field directive uses this validation object to watch errors
         */
        if(groupName && validationObject) {
          // pass on the validation configuration for this group
          var groupLevelValidationObject = $parse(angularElement.attr('validations'))($scope) || validationObject[groupName] || {};
          groupLevelValidationObject.ignore = groupLevelValidationObject.ignore || {};

          // set validations for this form, this way bento-fm-field will be benefited during validation
          FMUtilsService.setAttribute(angularElement, 'validations', JSON.stringify(groupLevelValidationObject));
          self.processFormElements(angularElement.children(), groupLevelValidationObject, $parse);
        }
        else {
          self.processFormElements(angularElement.children(), validationObject, $parse);
        }
      });
    };
  }
}(window.angular));

(function (angular) {
  'use strict';

  angular.module('bento-fm.core').directive('bentoFmGroup', FmGroup);
  angular.module('bento-fm.core').controller('bentoFmGroupController', FmGroupController);

  FmGroup.$inject = [];

  function FmGroup() {
    return {
      restrict  : 'A',
      require   : ['^^bentoFmForm', 'form', 'bentoFmGroup'],
      controller: 'bentoFmGroupController',
      link      : function (scope, element, attrs, forms) {
        // set id and label for this element
        forms[2].init(forms);
      }
    };
  }

  FmGroupController.$inject = ['$log', '$parse', '$scope', '$element', '$attrs', '$timeout', 'FMUtilsService', 'FMErrorHandlerService'];

  function FmGroupController($log, $parse, $scope, $element, $attrs, $timeout, FMUtilsService, FMErrorHandlerService) {
    var parentForm;
    var groupForm;
    var self = this;
    var changeTimeoutCancel;

    /*
     * if setValidity isn't called within this time, BFM will log an error on
     * the console
     */
    this.GROUP_VALIDATE_TIMEOUT = 5000;

    this.element = $element;

    /*
     * Set 'id' attribute, if not present.
     * For ARIA, set 'aria-labelledby', 'role' attributes
     */
    self.init = function (forms) {
      parentForm = forms[0];
      groupForm = forms[1];

      // only when the attribute is defined
      if ($attrs.groupValidate) {
        self.groupValidate = $parse($attrs.groupValidate);
      }

      // only when group validate timeout is defined
      if ($attrs.groupValidateTimeout) {
        self.GROUP_VALIDATE_TIMEOUT = $attrs.groupValidateTimeout;
      }

      /*
       * 1. Only when the attribute is defined & the attribute value is not null or
       * 2. If errorHandler attribute is null or
       * 3. look at the parent level (form level)
       */
      if ($attrs.errorHandler && $attrs.errorHandler !== 'null') {
        self.errorHandler = $parse($attrs.errorHandler);
      } else if ($attrs.errorHandler && $attrs.errorHandler === 'null') {
        self.errorHandler = undefined;
      } else if (parentForm.element && parentForm.element.attr('error-handler')) {
        self.errorHandler = $parse(parentForm.element.attr('error-handler'));
      }

      /*
       * 1. Only when the attribute is defined & the attribute value is not null or
       * 2. If validateOnBlurOnly attribute is null or
       * 3. look at the parent level (form level)
       */
      if ($attrs.validateOnBlurOnly && $attrs.validateOnBlurOnly !== 'null') {
        this.validateOnBlurOnly = $parse($attrs.validateOnBlurOnly);
      } else if ($attrs.validateOnBlurOnly && $attrs.validateOnBlurOnly === 'null') {
        this.validateOnBlurOnly = undefined;
      } else if (parentForm.element && parentForm.element.attr('validate-on-blur-only')) {
        this.validateOnBlurOnly = $parse(parentForm.element.attr('validate-on-blur-only'));
      }

      // set 'id' attribute, if not present
      FMUtilsService.setAttribute($element, 'id', FMUtilsService.generateRandomId());

      // set with the same 'id' - either given by the user or by the previous method
      FMUtilsService.setAttribute($element, 'aria-labelledby', FMUtilsService.getAttribute($element, 'id'));

      FMUtilsService.setAttribute($element, 'role', 'group');

      // Only validate when the form doesn't have any errors
      if (angular.equals(groupForm.$error, {})) {
        // with options group, better to disable the form even before user interacts with it
        self.validateGroupWithCallback(groupForm, function (validationResult) {
          if (validationResult.valid) {
            // reset the group form's validity
            groupForm.$setValidity(FMUtilsService.getAttribute($element, 'bento-fm-group'), true);
          }
        });
      }
    };

    /**
     * Call user defined group validation callback, if there are no errors
     */
    self.groupValidateIfNoErrors = function () {
      // Make sure all ngModels are commit
      self.validateGroupWithCallback(groupForm, function (validationResult) {
        if (validationResult.valid) {
          // reset the group form's validity
          groupForm.$setValidity(FMUtilsService.getAttribute($element, 'bento-fm-group'), true);
        }
        self.processGroupValidateMessage(validationResult);
      });

    };

    self.setBlurred = function () {
      var flag = '$dirty';

      if (
        ($attrs.groupValidateOnBlur && $parse($attrs.groupValidateOnBlur)($scope)) ||
        self.getElementStatus(flag)
      ) {
        self.validateGroupWithCallback(groupForm, function (validationResult) {
          if (validationResult.valid) {
            // reset the group form's validity
            groupForm.$setValidity(FMUtilsService.getAttribute($element, 'bento-fm-group'), true);
          }
          self.processGroupValidateMessage(validationResult);
        });
      }
    };

    self.setChanged = function (changed) {
      if (changeTimeoutCancel) {
        $timeout.cancel(changeTimeoutCancel);
      }

      // We to debounce the error checking
      changeTimeoutCancel = $timeout(function () {
        self.groupValidateIfNoErrors();
      });
    };

    // Get validations object at this level
    self.validationObject = $parse($attrs.validations)($scope) || {};
    /**
     * Get error message from this group level
     */
    self.getErrorMessageByKey = function (key) {
      var errorMessage = self.validationObject[key];
      if (errorMessage && errorMessage.length) {
        return errorMessage;
      } else {
        return parentForm.getErrorMessageByKey(key);
      }
    };

    /**
     * Check whether all child controls are filled. Group validation call
     * back gets called only when this function returns true
     */
    self.getElementStatus = function (flag) {
      var elementStatus = 0;
      var controls = [];

      // use this logic to get $$controls instead of directly accessing, their
      // private member '$$controls'
      angular.forEach(groupForm, function (value) {
        if (typeof value === 'object' && value.hasOwnProperty('$modelValue')
          && value.hasOwnProperty('$$attr') && value.$$attr.hasOwnProperty('bentoFmField')) {
          controls.push(value);
        }
      });

      // if the group contains checkbox, then check with 1st element and return if checkbox
      if (controls[0].$$element[0].tagName.toLowerCase() === 'input'
        && controls[0].$$element[0].type.toLowerCase() === 'checkbox') {
        return controls[0][flag];
      }

      for (var i = 0; i < controls.length; i++) {
        if ((controls[i][flag] ||
            (controls[i].$modelValue && controls[i].$modelValue.length))
        ) {
          elementStatus++;
        }
      }

      return elementStatus === controls.length;
    };

    /**
     * call back the dev specific business logic and based on the return value - show/hide error
     * @param ret
     */
    self.processGroupValidateMessage = function (ret) {
      // if the custom validation is not valid, show the error message
      if (ret && !ret.valid) {
        if (ret.message && ret.message.length) {
          // show user sent error message
          if (self.errorHandler) {
            self.errorHandler($scope, {hasError: true, element: $element, message: ret.message});
          }
          if (!FMUtilsService.getAttribute($element, 'aria-errormessage')) {
            FMErrorHandlerService.constructErrorElement($element);
          }
          FMErrorHandlerService.showError($element, ret.message);
        } else {
          var groupLabel = FMUtilsService.getAttribute($element, 'name');
          if ($attrs.bentoFmLabel) {
            // do not format the label
            groupLabel = $attrs.bentoFmLabel;
          } else {
            //no explicit label specified, format group name and use that as label
            groupLabel = FMUtilsService.formatCamelCaseString(FMUtilsService.UCFirst(groupLabel));
          }
          // show generic error
          var errorMessage = FMUtilsService.formatValidationMessage(
            FMUtilsService.defaultValidationMessages.defaultgrouperror, groupLabel);

          if (self.errorHandler) {
            self.errorHandler($scope, {hasError: true, element: $element, message: errorMessage});
          }
          if (!FMUtilsService.getAttribute($element, 'aria-errormessage')) {
            FMErrorHandlerService.constructErrorElement($element);
          }
          FMErrorHandlerService.showError($element, errorMessage);
        }
        // reset the forms's validity
        groupForm.$setValidity(FMUtilsService.getAttribute($element, 'bento-fm-group'), false);
      } else {
        // reset errors
        if (self.errorHandler) {
          self.errorHandler($scope, {hasError: false, element: $element, message: ''});
        }
        if (!FMUtilsService.getAttribute($element, 'aria-errormessage')) {
          FMErrorHandlerService.constructErrorElement($element);
        }
        FMErrorHandlerService.resetError($element);
        //set it back to true
        groupForm.$setValidity(FMUtilsService.getAttribute($element, 'bento-fm-group'), true);
      }
    };

    self.validateGroupWithCallback = function (groupForm, processGroupValidateReturn) {
      var setValidityIsCalled = false;

      // set the form's validity to false, if valid, the callee will reset the form's validity
      groupForm.$setValidity(FMUtilsService.getAttribute($element, 'bento-fm-group'), false);

      var validationResultDeprecated = self.groupValidate($scope, {
        groupForm  : groupForm,
        setValidity: function sv(validationResult) {
          setValidityIsCalled = true;
          processGroupValidateReturn(validationResult);
        }
      });

      // using old return method, warn them as this will be soon deprecated
      if (validationResultDeprecated) {
        $log.warn('BFM Group: This API signature of `group-validate` will be ' +
          'deprecated in next release (v1.2+). Please refer BFM\'s API document for new usage', $element[0]);
        processGroupValidateReturn(validationResultDeprecated);
      } else {
        $timeout(function warningTimeout() {
          if (!setValidityIsCalled) {
            $log.error('BFM Group: Set Validity not called yet', $element[0]);
          }
        }, this.GROUP_VALIDATE_TIMEOUT);
      }
    };
  }

}(window.angular));

(function (angular) {
  'use strict';

  angular.module('bento-fm.core').directive('bentoFmSubmit', FmSubmit);

  function FmSubmit() {
    return {
      restrict: 'A',
      require : ['^form'],
      link    : function (scope, element, attrs, form) {
        var formCtrl = form[0];
        var self = this;

        setSubmitButtonStatus();

        /*
        Override $invalid with setter and getter
        */
        Object.defineProperty(formCtrl, '$invalid', {
          get: function () {
            return self.$invalid;
          },
          set: function (v) {
            self.$invalid = v;
            setSubmitButtonStatus();
          }
        });

        function setSubmitButtonStatus() {
          var hasError = false;

          for (var e in formCtrl.$error) {
            // All we need to know is that there is an error in the $error object
            // since formControl.$invalid is not dependable sometimes
            hasError = true;
            break;
          }

          // Set attributes to this Submit button
          attrs.$set('disabled', hasError);
          attrs.$set('aria-invalid', hasError);
          attrs.$set('aria-disabled', hasError);
        }
      }
    };
  }

  FmSubmit.$inject = [];
}(window.angular));

(function(angular) {
  'use strict';

  angular.module('bento-fm.core').service('FMErrorHandlerService', FMErrorHandlerService);
  FMErrorHandlerService.$inject = ['$log', 'FMCONSTANTS', 'FMUtilsService', 'FMOptionService', '$templateCache', '$compile', '$rootScope', '$timeout'];

  function FMErrorHandlerService($log, FMCONSTANTS, FMUtilsService, FMOptionService, $templateCache, $compile, $rootScope, $timeout) {
    /*
     * Map (errorElementId) of maps (errorMessages) with count
     * To consolidate all similar errors, BFM using this map
     */
    var errorContainerErrorMap = {};

    function isContainerIdPresent(containerId) {
      return !!errorContainerErrorMap[containerId];
    };

    function isErrorMessagePresent(containerId, errorMessage) {
      return !!errorContainerErrorMap[containerId][errorMessage];
    };

    function addToErrorMap(containerId, errorMessage, errorElementId) {
      var errorMessageArray;

      if(!isContainerIdPresent(containerId)) {
        errorContainerErrorMap[containerId] = {};
      } 
      
      if(!isErrorMessagePresent(containerId, errorMessage)) {
        errorContainerErrorMap[containerId][errorMessage] = errorMessageArray = [errorElementId];
      } else {
        errorMessageArray = errorContainerErrorMap[containerId][errorMessage];
        var index = errorMessageArray.indexOf(errorElementId);
        
        if(index === -1) {
          errorMessageArray.push(errorElementId);
        }
      }

      return errorMessageArray.length;
    };

    function removeFromErrorMap(containerId, errorMessage, errorElementId) {
      var errorMessageArray;
      if(isContainerIdPresent(containerId) && isErrorMessagePresent(containerId, errorMessage)) {
        errorMessageArray = errorContainerErrorMap[containerId][errorMessage];
        var index = errorMessageArray.indexOf(errorElementId);
  
        if(index > -1) {
          errorMessageArray.splice(index,1);
        }
      } else {
        errorMessageArray = [];
      }

      return errorMessageArray.length;
    };

    function getNextErrorIdFromErrorMap(containerId, errorMessage) {
      if(isContainerIdPresent(containerId) && isErrorMessagePresent(containerId, errorMessage)) {
        var errorMessageArray = errorContainerErrorMap[containerId][errorMessage];
        if(errorMessageArray.length > 0) {
          return errorMessageArray[0];
        }
      }

      return undefined;
    };

    function insertElementAfter(elementAfter, elementToInsert) {
      var parentNode = elementAfter.parentNode;
      var nextSibling = elementAfter.nextSibling;

      if(nextSibling) {
        parentNode.insertBefore(elementToInsert, nextSibling);
      } else {
        parentNode.appendChild(elementToInsert);
      }
    }
    
   
    /*
     * Iteratively find error container
     *
     * This is currently appending all errors into on location
     * Will need to implement errors that show up in different locations
     *
     * @param element
     */
    this.findElementAttributeValue = function(element, eAttribute) {
      var attributeValue = null;
      var e = element;
      do {
        if(!e[0] || !e[0].tagName) {
          // without this condition it'll go infinitely
          break;
        }
        /*
         * look for the error-container on the element only when
         * 1. it has 'ng-form' attribute or
         * 2. if its a 'form' element
         */
        // if(FMUtilsService.hasAttribute(e, 'ng-form') || e[0].tagName.toLowerCase() === 'form') {
        if(FMUtilsService.hasAttribute(e, eAttribute)) {
          attributeValue = e.attr(eAttribute);
          break;
        }
      } while(e = e.parent());

      if(!attributeValue) {
        // get default value for this attribute from option service
        attributeValue = FMOptionService.getDefaultValue(eAttribute);
      }

      return attributeValue;
    };

    /**
     * Append element into an error message area
     *
     * This is currently appending all errors into on location
     * Will need to implement errors that show up in different locations
     *
     * @param element
     */
    this.constructErrorElement = function(element) {
      var errorContainer = this.findElementAttributeValue(element, 'error-container');
      var id = 'notify'+FMUtilsService.getAttribute(element, 'id');

      if ( FMUtilsService.isElementRadioOrCheckbox(element) ) {
        return;
      }
      // construct only if the element with this id is not present
      if(document.querySelector('#'+id)) {
        $log.warn('id: "', id, '" is repeating on the DOM', element[0]);
        return;
      }
      var muteError = this.findElementAttributeValue(element, 'mute-error');
      if(muteError === 'true') {
        // dev is going to override the error template, so don't do anything, just return
        return;
      }

      var errorElement = null;
      var errorTemplate = this.findElementAttributeValue(element, 'error-template');      
      if(errorTemplate) {
        element.isoScope = $rootScope.$new(true);

        // dev has specified error template, use that
        var templateElement = $templateCache.get(errorTemplate);
        if(templateElement) {
          errorElement = angular.element(templateElement);
          $compile(errorElement)(element.isoScope);
        } else {
          $log.error('Invalid error template "'+errorTemplate+'"', element[0]);
        }
      }

      FMUtilsService.setAttribute(errorElement, 'id', id);
      FMUtilsService.setAttribute(errorElement, 'role', 'alert');
      FMUtilsService.setAttribute(errorElement, 'aria-live', 'assertive');
      errorElement.css('display', 'none');

      /*
      * set aria-errormessage on this element.
      * so that whenenever error pops up on this element,
      * AT will look for element with aria-live='assertive' & starts
      * reading out the value of the div error element
      */
      FMUtilsService.setAttribute(element, 'aria-errormessage', id);

      if(!errorContainer) {
        // dev has not specified error-container, so stick error element below this element
        element.after(errorElement);
      } else {
        var elementToAppend = document.querySelector(errorContainer);
        if(elementToAppend) {
          elementToAppend.appendChild(errorElement[0]);
        } else {
          // 'error-container' attribute is present, but no element that has the value of 'error-container'
          $log.error('No element with id = "'+errorContainer+'"', element[0]);
        }
      }
      return errorElement;
    };

    /**
     * @param element
     * @param errorMessage
     */
    this.showError = function(element, errorMessage) {
      var errorElementId = '#notify' + element.attr('id');
      var errorElement = document.querySelector(errorElementId);

      if(errorElement) {
        errorElement = angular.element(errorElement);
        var messageToShow = (errorMessage)?errorMessage:element[0].validationMessage;
        element.addClass(FMCONSTANTS.errorClass + 'invalid');

        // wrap it inside $timeout to update new error message.
        $timeout(function() {
          if(element.isoScope) {
            element.isoScope.error = {
              message: messageToShow
            };
          } else {
            errorElement.text(messageToShow);
          }
        })

        errorElement.addClass(FMCONSTANTS.errorClass+'error');
        FMUtilsService.setAttribute(element, 'aria-invalid', true);

        // do it only if the element is `bento-fm-field`
        if(FMUtilsService.hasAttribute(element, 'bento-fm-field')) {
          var containerId = this.findElementAttributeValue(element, 'error-container');
          /*
           * if any element or its any of its parents don't have error-container, 
           * then do not apply error consolidation logic for that element; just 
           * show the error message 
           */
          if(!containerId || addToErrorMap(containerId, messageToShow, errorElementId) <= 1) {
            errorElement.css('display', 'block');
          }
        } else {
          errorElement.css('display', 'block');
        }
      } else {
        var muteError = this.findElementAttributeValue(element, 'mute-error');
        if(muteError === 'true') {
          return;
        }
      }
    };

    /**
     * Reset the current error
     * @param element
     */
    this.resetError = function(element) {
      var errorElementId = '#notify'+element.attr('id');
      var errorElement = document.querySelector(errorElementId);
      
      if(errorElement) {
        errorElement = angular.element(errorElement);
        var containerId = this.findElementAttributeValue(element, 'error-container');
        var count = removeFromErrorMap(containerId, errorElement.text(), errorElementId);
        
        //still there are some errors, clear it all
        if(count >= 0) {
          if ( errorElement && 'block' === errorElement.css('display') ) {
            //show next error from the error map
            var nextErrorElement;
            var nextErrorElementId = getNextErrorIdFromErrorMap(containerId, errorElement.text());
            if(nextErrorElementId) {
              nextErrorElement = document.querySelector(nextErrorElementId);
              nextErrorElement.style.display = 'block';

              insertElementAfter(errorElement[0], nextErrorElement);
            }
          }

          errorElement.css('display', 'none');
          errorElement.removeClass(FMCONSTANTS.errorClass+'error');
        }
      }

      element.removeClass(FMCONSTANTS.errorClass+'invalid');
      FMUtilsService.removeAttribute(element, 'aria-invalid');
    };
  }
}(window.angular));

(function (angular) {
  'use strict';

  angular.module('bento-fm.core').service('FMOptionService', FMOptionService);

  FMOptionService.$inject = ['$log', '$templateCache'];
  function FMOptionService($log, $templateCache) {
    var DEFAULT_ERROR_TEMPLATE_NAME = 'bfm-default-error-template.html';
    var defaultTemplate =  '<div><span class="error-message">{{error.message}}</span></div>';

    this.bfmOption = {
      errorContainer: '', // for now the default error container is right next to each element
      errorTemplate: DEFAULT_ERROR_TEMPLATE_NAME
    };

    this.init = function () {
      $templateCache.put(
        DEFAULT_ERROR_TEMPLATE_NAME, defaultTemplate);
    };

    this.setOption = function (bfmOption) {
      this.bfmOption = bfmOption;
    };

    this.getOption = function () {
      return this.bfmOption;
    };

    this.setErrorContainer = function (ec) {
      this.bfmOption.errorContainer = ec;
    };

    this.getErrorContainer = function () {
      return this.bfmOption.errorContainer;
    };

    this.setErrorTemplate = function (et) {
      this.bfmOption.errorTemplate = et;
    };

    this.getErrorTemplate = function () {
      return this.bfmOption.errorTemplate;
    };

    this.getDefaultValue = function (elementAttribute) {
      var defaultValue = null;
      switch (elementAttribute) {
        case 'error-template':
          defaultValue = this.bfmOption.errorTemplate
          break;
      }

      return defaultValue;
    };

    this.init();
  }
}(window.angular));

(function (angular) {
  'use strict';

  angular.module('bento-fm.core').service('FMUtilsService', FMUtils);

  function FMUtils($log, $parse) {
    this.defaultPatterns = {
      email : '/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i',
      url   : 'http?://.+',
      name  : '^[a-zA-Z](\s?[a-zA-Z]){1,30}$',
      number: '/\[0-9]/g'
    };

    this.defaultValidationMessages = {
      required         : '{0} is required',
      email            : 'The {0} field pattern is not valid',
      minlength        : '{0} must be at least {1} character(s)',
      maxlength        : '{0} must be less than or equal to {1} character(s)',
      min              : '{0} must be at least {1}',
      max              : '{0} must be at most {1}',
      pattern          : 'Invalid {0} pattern',
      url              : '{0} must be a valid URL',
      number           : '{0} must be a number',
      unknown          : '{0} is invalid',
      defaultgrouperror: 'Invalid {0}',
      validationTitle  : 'There are some validation errors'
    };

    this.isElementSupported = function (element) {
      var supported = false;
      var tagName = element[0].tagName.toLowerCase();

      switch (tagName) {
        case 'input':
          supported = this.isElementTypeSupported(element[0].type.toLowerCase());
          break;

        case 'select':
          supported = true;
          break;
      }

      return supported;
    };

    this.isElementTypeSupported = function (type) {
      var supported = false;
      switch (type) {
        case 'text':
        case 'number':
        case 'email':
        case 'radio':
        case 'checkbox':
        case 'url':
        case 'submit':
          supported = true;
          break;
      }

      return supported;
    };

    this.generateElementBasedId = function (ctrls) {
      return ctrls[0].$name + '-' + ctrls[1].$$element[0].type.toLowerCase() + '-' + ctrls[1].$name;
    };

    this.generateRandomId = function () {
      return Date.now() + Math.ceil(Math.random() * 9999);
      // var pn = performance.now()+'';
      // var i = pn.indexOf('.');
      // pn = pn.substr(0, i) + pn.substring(i+1, pn.length)
      // pn = Number(pn)+Math.ceil(Math.random()*9999);
      // return pn+'';
    };

    this.UCFirst = function (s) {
      return (typeof s === 'string') ? s.charAt(0).toUpperCase() + s.slice(1) : s;
    };

    this.formatValidationMessage = function (format) {
      if (format) {
        var self = this;
        var args = Array.prototype.slice.call(arguments, 1);
        var formattedString = format.replace(/{(\d+)}/g, function (match, number) {
          return typeof args[number] !== 'undefined' ?
            // self.formatCamelCaseString(self.UCFirst(args[number])) : match;
            args[number] : match;
        });

        // formattedString = formattedString.substr(0, 1).toUpperCase() + formattedString.substr(1);
        return formattedString.trim();
      }

      //no message with the attribute name
      return '';
    };

    this.formatCamelCaseString = function(str) {
      if(typeof str === 'number') {
        return str + '';
      }

      var res = str.replace(/[A-Z0-9]/g, function (match) {
        return ' ' + match;
      });
      res = res.substr(0, 1).toUpperCase() + res.substr(1);
      return res.trim();
    };

    this.setProperty = function (element, name, value, forceSet) {
      //set the attribute only if not present or if set forcefully
      if (!element.prop(name) || forceSet) {
        (value !== undefined && value !== null) ? element.prop(name, value) : element.prop(name, true);
      }
    };

    this.setAttribute = function (element, name, value, forceSet) {
      //set the attribute only if not present or if set forcefully
      if (!element.attr(name) || forceSet) {
        (value !== undefined && value !== null) ? element.attr(name, value) : element.attr(name, true);
      }
    };

    this.hasAttribute = function (element, attributename) {
      return element[0].hasAttribute(attributename)
    };

    this.getAttribute = function (element, name) {
      return element.attr(name);
    };

    this.removeAttribute = function (element, name) {
      if (element.attr(name)) {
        element.removeAttr(name);
      }
    };

    this.createHTMLElement = function (tag, attributes) {
      var newElement = angular.element(tag);
      for (var key in attributes) {
        newElement.attr(key, attributes[key]);
      }

      return newElement;
    };

    this.isLabelAlreadyDefined = function (element, formElement) {
      var previousElement = element[0].previousElementSibling;
      var parentElement = element[0].parentElement;
      var labelElement;
      var id = this.getAttribute(element, 'id');

      /**
       * 1. check if the previous element is 'label'
       * 2. or check if the input is surrounded by 'label'
       * 3. or check if input element's id attribute and any label's 'for' attribute matches
       * (within this form)
       */
      if (previousElement && previousElement.tagName.toLowerCase() === 'label') {
        labelElement = angular.element(previousElement);
      } else if (parentElement && parentElement.tagName.toLowerCase() === 'label') {
        labelElement = angular.element(parentElement);
      }

      /**
       * To avoid calling querySelector twice in the previous condition like this
       * else if(formElement[0].querySelector('label[for="'+id+'"]')) {
       *   labelElement = formElement[0].querySelector('label[for="'+id+'"]');
       * }
       * Putting this as a seperate condition when labelElement is not present.
       */
      if (!labelElement) {
        labelElement = formElement[0].querySelector('label[for="' + id + '"]');
        if (labelElement) {
          labelElement = angular.element(labelElement);
        }
      }

      return labelElement;
    };

    this.isElementRadioOrCheckbox = function (element) {
      var radioOrCheck = false;
      if (element[0].tagName.toLowerCase() === 'input' &&
        (element[0].type.toLowerCase() === 'radio' || element[0].type.toLowerCase() === 'checkbox')) {
        radioOrCheck = true;
      }

      return radioOrCheck;
    };

    /**
     * These methods are used by both bento-group & bento-fm-field
     */

    /**
     * Add a hidden label to this input with few ARIA attributes and 'for' attribute
     * Notes: No matter what, even if dev had specified a label tag, this code will
     * again create another hidden label. This needs to be "re-visited".
     *
     * @param element
     * @param attrs
     * @param formElement
     */
    this.addLabel = function (element, attrs, formElement) {
      if (this.isElementRadioOrCheckbox(element)) {
        return;
      }
      var labelElement = this.isLabelAlreadyDefined(element, formElement);
      if (labelElement && !this.getAttribute(element.parent(), 'bento-fm-group')) {
        /**
         * if present, verify 'for' attribute of the label &
         * 'id' attribute of the element to which it has to attach
         */
        var forAttribute = this.getAttribute(labelElement, 'for');
        var idAttribute = this.getAttribute(element, 'id');
        var isGroup = this.getAttribute(element, 'bento-fm-group');

        if (!isGroup && forAttribute !== idAttribute) {
          // only show this warning if the element is NOT a group
          $log.warn('Non matching for & id attributes ', element[0]);
        }

        // change the 'for' attribute for the element - can we do this? Jagan
        this.setAttribute(labelElement, 'for', idAttribute);
      }
      else {
        var labelName = attrs.name || attrs.placeholder || attrs.type;
        var requiredStar = (attrs.required || attrs['ng-required']) ? '*' : '';
        labelElement = angular.element(
          '<label for=' + this.getAttribute(element, 'id') + '>' + labelName + ' ' + requiredStar + '</label>');
        labelElement.attr('aria-hidden', true);
        labelElement.css('display', 'none');
        element.parent()[0].insertBefore(labelElement[0], element[0]);
      }
    };
  }

  FMUtils.$inject = ['$log', '$parse'];
}(window.angular));

(function(angular) {
  'use strict';
  angular.module('bento-fm.core').constant('FMCONSTANTS', {
    errorClass: 'bento-fm-'
  });

}(window.angular));
